"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonEncryptRequestImpl = void 0;
var encrypt_abstract_1 = require("./encrypt-abstract");
var common_encrypt_1 = __importDefault(require("../../encrypt/common-encrypt"));
var request_1 = __importDefault(require("../request"));
var helper_factory_1 = __importDefault(require("../../helper/helper-factory"));
var helper_1 = require("../../../core/helper");
var encrypt = new common_encrypt_1.default();
var config;
var CommonEncryptRequestImpl = /** @class */ (function (_super) {
    __extends(CommonEncryptRequestImpl, _super);
    function CommonEncryptRequestImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommonEncryptRequestImpl.prototype.initConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var baseUrl, promise, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        baseUrl = (0, helper_1.getBaseUrl)();
                        promise = request_1.default.load({
                            url: "".concat(baseUrl, "/ai_entry/v3/encrypted/info"),
                            method: 'get',
                            headers: helper_factory_1.default.getAiServerHeaders(),
                        })[0];
                        return [4 /*yield*/, promise];
                    case 1:
                        response = _a.sent();
                        config = response.data;
                        config && encrypt.init(config);
                        return [2 /*return*/];
                }
            });
        });
    };
    CommonEncryptRequestImpl.prototype.setConfigAndEncrypt = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!config) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.initConfig()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, encrypt.encrypt({
                            content: data,
                            isEncryptHeaders: true
                        })];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CommonEncryptRequestImpl.prototype.getUrl = function (url, baseUrl) {
        if (!url.startsWith('http')) {
            return "".concat(baseUrl || (0, helper_1.getBaseUrl)()).concat(url);
        }
        return url;
    };
    CommonEncryptRequestImpl.prototype.request = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, data, method, url, baseUrl, headers, reset, _b, _data, _headers, headersV3, mergedHeaders, promise, _responseResult, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, , 4]);
                        _a = params.data, data = _a === void 0 ? '' : _a, method = params.method, url = params.url, baseUrl = params.baseUrl, headers = params.headers, reset = __rest(params, ["data", "method", "url", "baseUrl", "headers"]);
                        return [4 /*yield*/, this.setConfigAndEncrypt(data)];
                    case 1:
                        _b = _c.sent(), _data = _b.content, _headers = __rest(_b, ["content"]);
                        headersV3 = helper_factory_1.default.getAiServerHeaders();
                        mergedHeaders = helper_factory_1.default.getObjKeysMerged(headersV3, headers);
                        promise = this.load(__assign(__assign({}, reset), { method: method, url: this.getUrl(url, baseUrl), body: method.toLocaleLowerCase() === 'get' ? data : _data, headers: __assign(__assign({}, mergedHeaders), _headers) }))[0];
                        return [4 /*yield*/, promise];
                    case 2:
                        _responseResult = _c.sent();
                        if (_responseResult && _responseResult.data) {
                            _responseResult.data = JSON.parse(encrypt.decrypt(_responseResult.data));
                        }
                        return [2 /*return*/, _responseResult];
                    case 3:
                        e_1 = _c.sent();
                        // TODO: 改造成promise请求
                        // throw e
                        console.log('[ai sdk CommonEncryptRequestImpl request error', e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CommonEncryptRequestImpl.prototype.requestCancelable = function (params) {
        var _this = this;
        var _a = params.data, data = _a === void 0 ? '' : _a, url = params.url, baseUrl = params.baseUrl, _b = params.headers, headers = _b === void 0 ? {} : _b, reset = __rest(params
        // TODO: 后续处理setEncryptCb
        // const { content: _data, ..._headers } = await this.setConfigAndEncrypt(data)
        , ["data", "url", "baseUrl", "headers"]);
        // TODO: 后续处理setEncryptCb
        // const { content: _data, ..._headers } = await this.setConfigAndEncrypt(data)
        var headersV3 = helper_factory_1.default.getAiServerHeaders();
        var mergedHeaders = helper_factory_1.default.getObjKeysMerged(headersV3, headers);
        try {
            var _c = this.load(__assign(__assign({}, reset), { url: this.getUrl(url, baseUrl), body: data, headers: __assign({}, mergedHeaders), setEncryptCb: function (data) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.setConfigAndEncrypt(data)];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                }); } }), encrypt.decrypt), promise = _c[0], controller_1 = _c[1];
            var abortFn = function () {
                controller_1.abort();
            };
            return [promise, abortFn];
        }
        catch (e) {
            // TODO: 改造成promise请求
            // throw e
            // console.error('[ai sdk CommonEncryptRequestImpl requestCancelable error', e)
            // 异常抛出400+给业务处理
            return e;
        }
    };
    return CommonEncryptRequestImpl;
}(encrypt_abstract_1.EncryptRequestAbstract));
exports.CommonEncryptRequestImpl = CommonEncryptRequestImpl;
exports.default = new CommonEncryptRequestImpl();
